<template>
  <div id="percent-box" v-if="data.items && data.items.length > 0">
    <template v-if="getType === 'line'">
      <div class="analyse-percent-group">
        <div class="percent-row" v-for="item in data.items">
          <div class="percent-prepend">{{ item.label }}</div>
          <div class="percent-progress">
            <el-tooltip effect="dark" :content="item.label + ': ' + item.percent + '%'" placement="top">
              <el-progress :type="getType" :text-inside="true" :stroke-width="25" :color="colors[Math.ceil(item.percent / 25)]"
                           :percentage="item.percent"></el-progress>
            </el-tooltip>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="circle-percent-group analyse-percent-group">
        <div class="circle-item" :style="circleStyle" v-for="item in data.items">
          <div class="circle-item-progress">
            <el-progress :type="getType" :stroke-width="percentStrokeWidth" :width="data.items.length === 1 ? 200 : 120" :color="colors[Math.ceil(item.percent / 25)]" :percentage="item.percent"></el-progress>
          </div>
          <span class="circle-item-label" v-if="item.label && item.label !== null && item.label !== ''">
            {{ item.label }}
          </span>
        </div>
      </div>
    </template>
  </div>
  <show-no-data v-else></show-no-data>
</template>

<script>
  import ShowNoData from '../show-no-data'
  export default {
    components: {
      ShowNoData
    },
    props: {
      data: {
        type: 'Object'
      }
    },
    data() {
      return {
        colors: [
          '#f56c6c',
          '#e6a23c',
          '#4472c4',
          '#5cb87a']
      }
    },
    name: 'percent-config',
    typeCode: '8',
    computed: {
      getType: function () {
        return this.data.isCircle !== undefined && this.data.isCircle ? 'circle' : 'line'
      },
      percentStrokeWidth: function () {
        let width = 15 / this.data.items.length
        return width >= 10 ? width : 10
      },
      circleStyle: function () {
        let style = {}
        style.padding = this.data.items.length === 1 ? '0' : '0 ' + 120 / this.data.items.length + 'px'
        return style
      }
    }
  }
</script>

<style scoped>

  .analyse-percent-group {
    padding-top: 10px;
    text-align: center;
  }

  .analyse-percent-group .percent-row {
    position: relative;
    margin: 30px 0;
    padding-left: 80px;
    font-size: 14px;
    line-height: 30px;
  }

  .percent-prepend {
    left: 0;
  }

  .percent-prepend {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 1;
    line-height: 25px;
  }

  .percent-progress {
    cursor: pointer;
  }

  .circle-item {
    display: inline-block;
  }

  .circle-percent-group {
    padding: 0 !important;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: horizontal;
    -webkit-box-pack: center;
    -webkit-box-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/show/components/percent-config.vue